import { render, staticRenderFns } from "./PreviousHistory.vue?vue&type=template&id=14b1f8c8&scoped=true"
import script from "./PreviousHistory.vue?vue&type=script&lang=js"
export * from "./PreviousHistory.vue?vue&type=script&lang=js"
import style0 from "./PreviousHistory.vue?vue&type=style&index=0&id=14b1f8c8&prod&lang=less"
import style1 from "./PreviousHistory.vue?vue&type=style&index=1&id=14b1f8c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b1f8c8",
  null
  
)

export default component.exports